import * as React from "react";
import { UitkCardAloha, UitkCardAlohaContentSection } from "uitk-react-cards";
import { UitkHeading, UitkText, UitkSubheading } from "uitk-react-text";
import { ContentProps, EditorialFactoryProps } from "../../../typings";
import EditorialBase from "../../EditorialBase";
import IsomorphicCarousel from "src/components/shared/IsomorphicCarousel/IsomorphicCarousel";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { ItemKeyHelper } from "src/components/utility/ItemKeyHelper";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { useLocalization } from "@shared-ui/localization-context";
import { BlossomImage } from "src/components/shared/BlossomImage/BlossomImage";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";

export class CarouselEditorial extends EditorialBase {
  constructor(editorial: EditorialFactoryProps) {
    super(editorial);
  }

  public generate(props: ContentProps) {
    const { flexTemplateNode } = props;
    const itemsVisible = {
      lg: 3,
      md: 2,
      sm: 1,
    };
    const { formatText } = useLocalization();
    const keyHelper = new ItemKeyHelper(flexTemplateNode.id);

    return (
      <div className="editorial-carousel" data-testid="carousel-editorial" id={flexTemplateNode.id}>
        {this.editorial.title && (
          <UitkSpacing margin={{ block: "three", inline: "three" }}>
            <UitkHeading tag="h2" size={3}>
              {this.editorial.title}
            </UitkHeading>
          </UitkSpacing>
        )}
        <UitkSpacing margin={{ blockstart: "three", blockend: "unset", inlinestart: "three" }}>
          <IsomorphicCarousel
            itemsVisible={itemsVisible}
            buttonText={{
              nextButton: formatText("carousel.item.next"),
              prevButton: formatText("carousel.item.prev"),
            }}
            pageBy={1}
            peekWidth={1}
            wrapItems={false}
          >
            {this.editorial.items.map((editorialItem) => (
              <UitkCardAloha className="blossom-plain" key={keyHelper.next()}>
                <div data-testid="editorial-carousel-content">
                  <UitkLayoutGrid columns={1}>
                    {editorialItem.media && (
                      <UitkLayoutGridItem>
                        <UitkFigure ratio={UitkFigureAspectRatioType.R16_9} className="all-image-fit-cover">
                          <BlossomImage
                            src={editorialItem.media![0].mediaUrl}
                            alt={editorialItem.media[0].mediaAlt || ""}
                          />
                        </UitkFigure>
                      </UitkLayoutGridItem>
                    )}
                    <UitkLayoutGridItem>
                      <UitkCardAlohaContentSection>
                        <div
                          className="uitk-type-paragraph-300"
                          data-fm-content={editorialItem.id}
                          id={editorialItem.id}
                        >
                          {editorialItem.title && (
                            <UitkHeading tag="h3" size={6}>
                              {editorialItem.title}
                            </UitkHeading>
                          )}
                          {editorialItem.subtitle && <UitkSubheading>{editorialItem.subtitle}</UitkSubheading>}
                          {editorialItem.text && (
                            <UitkText>
                              <UitkSpacing padding={{ blockstart: "two" }}>
                                <div
                                  className="uitk-type-list-300"
                                  dangerouslySetInnerHTML={decorateEditorialHtml(editorialItem.text)}
                                />
                              </UitkSpacing>
                            </UitkText>
                          )}
                        </div>
                      </UitkCardAlohaContentSection>
                    </UitkLayoutGridItem>
                  </UitkLayoutGrid>
                </div>
              </UitkCardAloha>
            ))}
          </IsomorphicCarousel>
        </UitkSpacing>
      </div>
    );
  }
}
